export default {"src":"https://gfiber.com/support/_next/static/media/arrow_forward.af2387bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};